<template>
    <a-card :bordered="false">
        <s-table ref="table" size="default" :columns="columns" :data="loadData">
            <template slot="user_id" slot-scope="text, record">
                {{ text + 10000000}}
            </template>
            <template slot="type" slot-scope="text, record">
                {{ activeStr[text] || "未知类型" }}
            </template>
            <!-- <template slot="status" slot-scope="text, record">
                {{ statusStr[text] || "未知类型" }}
            </template> -->
        </s-table>
    </a-card>
</template>
<script>

import STable from '@/components/table/'
import AInput from 'ant-design-vue/es/input/Input'

import { getUserGameCoinRecords, getUser } from '@/api/user'

const activeStr = [
    "充值",
    "取币",
    "管理员手工取币",
    "管理员存币",
]

const statusStr = [
    "充值成功",
    "取币中",
    "取币完成",
    "管理员存币成功"
]

export default {
    name: "UserRecord",
    components: {
        AInput,
        STable
    },
    data() {
        return {
            activeStr,
            statusStr,
            visible: false,
            labelCol: {
                xs: { span: 24 },
                sm: { span: 5 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 12 },
            },
            form: null,
            mdl: {},
            // 查询参数
            searchForm: null,
            queryParam: {},
            // 表头
            columns: [
                {
                    title: '操作时间',
                    dataIndex: 'created'
                },
                {
                    title: '用户uid',
                    dataIndex: 'user_id',
                    scopedSlots: { customRender: 'user_id' },
                },
                {
                    title: "操作类型",
                    dataIndex: "type",
                    scopedSlots: { customRender: 'type' },

                },
                {
                    title: '操作数量',
                    dataIndex: 'change_coin_num'
                },
                {
                    title: '门店',
                    dataIndex: 'branch_name'
                },
                // {
                //     title: "操作状态",
                //     dataIndex: "status",
                //     scopedSlots: { customRender: 'status' },
                // },
                {
                    title: '操作员工',
                    dataIndex: 'admin_user_name',
                },
                {
                    title: '游戏币余额',
                    dataIndex: 'user_coin_num'
                },
            ],
            // 加载数据方法 必须为 Promise 对象
            loadData: params => {
                return getUserGameCoinRecords(Object.assign(params, { id: this.$route.params.id })).then(res => res)
            },
        }
    },
    created() {
    },
    methods: {

    },
}
</script>
<style scoped>

</style>

